import { Box, Flex, Group, Text, Title } from "@mantine/core";
import { GroupProductQuote, ProductQuote } from "@/types/api/quote";

import { calculateDiscountPercent } from "@/utils/calculate/calculateDiscount";
import styles from "./styles.module.scss";
import { toBRL } from "@/utils/formatters/formatCurrency";

interface ProductResumeProps {
  product: ProductQuote | GroupProductQuote;
  isGroup?: boolean;
}

export function ProductResume({ product }: ProductResumeProps) {
  return (
    <Flex className={styles.product} align="center" justify="space-between">
      <Box className={styles.productInfo}>
        <Title>
          {product!.name} <span>- {product!.quantity} uni.</span>
        </Title>
        <Text>{product!.description}</Text>

        {product!.finalAmount !== product!.unitAmount ? (
          <>
            {product!.type === "product" && (
              <Group className={styles.productInfoGroup}>
                <Text>
                  <span>{toBRL(product!.originalAmount)}</span>
                  Por: {toBRL(product!.finalAmount)}
                </Text>
                <Box>{product!.planDiscountPercentage} % OFF</Box>
              </Group>
            )}

            {product!.type === "group" && (
              <>
                <Group className={styles.productInfoGroup}>
                  <Text>
                    <span>{toBRL(product!.unitAmount)}</span>
                    Por: {toBRL(product!.finalAmount)}
                  </Text>
                  <Box>
                    {calculateDiscountPercent(
                      product!.unitAmount,
                      product!.finalAmount,
                    )}
                    % OFF
                  </Box>
                </Group>
              </>
            )}
          </>
        ) : (
          <Group className={styles.productInfoGroup}>
            <Text>{toBRL(product!.finalAmount)}</Text>
          </Group>
        )}
      </Box>
      <Box className={styles.productImage}>
        <img src={product!.images[0]} alt={product!.name} />
      </Box>
    </Flex>
  );
}
